var generic = generic || {};
var site = site || {};
(function ($) {
  site.offer = site.offer || {};
  site.offer.ui = site.offer.ui || {};

  site.offer.ui = {
    offercode : '',
    //get offer data
    getOfferData : function(offercode) {
      var self = this;
      site.onLoadRpc.requests.push({
        'method': 'offer',
        'params': [offercode],
        onSuccess: function(data) {
          var offer = data.result.value;
          var isActive = (offer && (offer.timing === 'active'));
          if(isActive) {
            $(document).trigger("offerData:"+offercode+":loaded", offer);
          }
        },
        onFailure: function(data) {}
      });
    },
    getOfferDataPcat : function(offercode) {
      var self = this;
      site.onLoadRpc.requests.push({
        'method': 'offer.pcat',
        'params': [{"OFFER_CODE": offercode}],
        onSuccess: function(data) {
          var offer = data.result.value;
          var isActive = (offer && (offer.timing === 'active'));
          if(isActive) {
            $(document).trigger("offerData:"+offercode+":loaded", offer);
          }
        },
        onFailure: function(data) {}
      });
    },
    //get trans data
    getTransData: function(){
      var itemCount = site.userInfoCookie.getValue('item_count');
      if(!_.isNull(itemCount) || !itemCount){
        site.onLoadRpc.requests.push({
          'method': 'trans.get',
          'params': [{
            'trans_fields' : ['TRANS_ID', 'totals'],
            'payment_fields' : [],
            'order_fields' : ['items', 'samples', 'offerCodes']
          }],
          onSuccess : function (data) {
            $(document).trigger("transData:loaded", data.result.value);
          },
          onFailure: function(data) {
            console.log('-- trans.get failed --');
            $(document).trigger("transData:loaded", 0);
          }
        });
      }else{
        $(document).trigger("transData:loaded", 0);
      }
    },
    //get product data
    getProductData: function(data,offercode) {
      var self = this;
      // consider support for products and categories
      // for now need to be skus
      //var type = ($.inArray('PROD', data[0]) > -1 || $.inArray('CAT', data[0]) > -1) ? 'products' : 'skus';
      var params = {
        //'query_key': 'catalog-spp',
        //'products': data
        'query_key': 'sku-to-product-data',
        'skus': data
      };
      //params[type] = data;
      generic.jsonrpc.fetch({
          method: 'prodcat.querykey',
          params: [params],
          onSuccess: function(response) {
            $(document).trigger("skus:"+offercode+":loaded", response.getValue());
          },
          onFailure: function (response) {
            console.log('-- prodcat.querykey failed --');
          }
      });
    },
    //add offer
    applyOffer : function(offercode, skuId) {
      var self = this;

      var skuBaseId = skuId.replace(/SKU/g,'');

      // offer.apply
      var params = {
        'offer_code' : offercode,
        'benefits': {
          'ChoiceOfSkus': {
            'choices': skuBaseId.split(',')
          }
        }
      };

      generic.jsonrpc.fetch({
        method: 'offers.apply',
        params: [params],
        onSuccess: function(response) {
          $(document).trigger("offer:"+offercode+":applied",response.getValue());
        },
        onFailure: function(response) {
          // display error
          console.log('-- error adding offer to cart --');
        }
      });
    },
    //remove offer - not currently in use
    removeOfferCart : function(offercode) {
      //offer.removeOfferByCode
      var self = this;
      var params = {
        'offer_code' : offercode
      };
      generic.jsonrpc.fetch({
        method: 'offer.removeOfferByCode',
        params: [params],
        onSuccess: function(response) {
          //console.log(response.getValue());
          //console.log(response.getMessages());
        },
        onFailure: function(response) {
          // display error
          console.log('-- error removing offer from cart --');
        }
      });
    }
  };
})(jQuery);

